import "./Dashboard.css";
import React, { Fragment, useEffect, useState } from "react";
import { Colors } from "../../Colors/Colors";
import NoRevenueChart from "../../assets/images/RevenueChart.png";
import NoPieChart from "../../assets/images/PieChart.png";

import { CalendarComponent } from "@syncfusion/ej2-react-calendars";

import { getLocalStorageItem } from "../../controllers/localStorage/getLocalStorage";
import GetAppointments from "../../controllers/appointments/GetAppointments";
import useOnclickOutside from "react-cool-onclickoutside";
import { isToday } from "date-fns";
import { isThisMonth } from "date-fns/esm";
import SyncPieChart from "../../Charts/SyncPieChart/SyncPieChart";
import SyncRevenueChart from "../../Charts/SyncRevenueChart/SyncRevenueChart";
import { Link, useNavigate } from "react-router-dom";

import { getAuth } from "firebase/auth";
import { MultipleQueryTypesense, QueryTypesense } from "../../Typesense";
import GetUser from "../../controllers/auth/GetUser";
import Counterup from "../../components/CountUp/Counterup";
import NoDataFound from "../../components/Common/NoDataFound/NoDataFound";
import AppointmentListingCard from "../../components/Common/AppointmentListingCard/AppointmentListingCard";

// Controllers End
const production = process.env.REACT_APP_MY_PRODUCTION;
const Dashboard = () => {
  const navigate = useNavigate();
  /** Search Query */

  const [OpenDeals, setOpenDeals] = useState(0);
  const [WonDeals, setWonDeals] = useState(0);
  const [LostDeals, setLostDeals] = useState(0);
  const [AutoLostDeals, setAutoLostDeals] = useState(0);
  const [RevenueChartData, setRevenueChartData] = useState([]);
  const [Result, setResult] = useState({});
  useEffect(() => {
    getAuth().onAuthStateChanged(async (user) => {
      const { email, verified_email } = await GetUser(user.uid);
      if (email !== "" && verified_email === false) {
        navigate("/verify/email");
      }
    });
  }, []);

  useEffect(() => {
    async function fetchData() {
      let result = {};

      let deals = await QueryTypesense(
        {
          q: getLocalStorageItem("bid"),
          query_by: "bid",
          per_page: 100,
        },
        "deals"
      );

      const openDeals = deals.filter(
        (word) => word.document.currentstatus === "open"
      );
      setOpenDeals(openDeals.length);

      const wonDeals = deals.filter(
        (word) => word.document.currentstatus === "won"
      );
      setWonDeals(wonDeals.length);

      const lostDeals = deals.filter(
        (word) => word.document.currentstatus === "lost"
      );
      const autoLostDeals = deals.filter(
        (word) => word.document.currentstatus === "Auto Lost"
      );
      setLostDeals(lostDeals.length);
      setAutoLostDeals(autoLostDeals.length);
      result.TotalOpenDeals = openDeals.length;
      result.TotalWonDeals = wonDeals.length;
      result.TotalLostDeals = lostDeals.length;
      result.TotalAutoLostDeals = autoLostDeals.length;
      /** properties data */
      result.properties = await MultipleQueryTypesense(
        {
          searches: [
            {
              q: "shared",
              query_by: "status",
              filter_by: `sharedParties:=[${getLocalStorageItem(
                "bid"
              )}] && is_deleted:=false`,
            },

            {
              filter_by: ` is_deleted:=false`,
              query_by: "bid",
              q: getLocalStorageItem("bid"),
            },
          ],
        },
        {
          collection: "properties",
        }
      );

      result.properties = result.properties.length;

      result.TotalLeads = (
        await QueryTypesense(
          {
            q: getLocalStorageItem("bid"),
            query_by: "bid",
            filter_by: "is_deleted:=false",
          },
          "leads"
        )
      ).length;

      /* Modifying dates in deals */
      deals = deals.map((e) => {
        const {
          document: { modifiedAt },
        } = e;
        let d = new Date(modifiedAt * 1000);
        const year = new Date().getFullYear().toString();
        d = d + "";
        d = d.split(year)[0] + year;
        e.document.modifiedAt = d;
        return { ...e };
      });

      /* Today Won Deals */
      result.TodayWonDeals = deals.filter(
        ({ document: { currentstatus, modifiedAt } }) =>
          currentstatus === "won" && isToday(new Date(modifiedAt))
      )?.length;

      /* This Month Won Deals */
      result.MonthWonDeals = deals.filter(
        ({ document: { currentstatus, modifiedAt } }) =>
          currentstatus === "won" && isThisMonth(new Date(modifiedAt))
      ).length;

      /* Today Lost Deals */
      result.TodayLostDeals = deals.filter(
        ({ document: { currentstatus, modifiedAt } }) =>
          currentstatus === "lost" && isToday(new Date(modifiedAt))
      ).length;
      /* This Month Lost Deals */
      result.MonthLostDeals = deals.filter(
        ({ document: { currentstatus, modifiedAt } }) =>
          currentstatus === "lost" && isThisMonth(new Date(modifiedAt))
      ).length;

      /* Today Auto Lost Deals */
      result.TodayAutoLostDeals = deals.filter(
        ({ document: { currentstatus, modifiedAt } }) =>
          currentstatus === "Auto Lost" && isToday(new Date(modifiedAt))
      ).length;
      /* This Month Auto Lost Deals */
      result.MonthAutoLostDeals = deals.filter(
        ({ document: { currentstatus, modifiedAt } }) =>
          currentstatus === "Auto Lost" && isThisMonth(new Date(modifiedAt))
      ).length;

      /* Today Open Deals */
      result.TodayOpenDeals = deals.filter(
        ({ document: { currentstatus, modifiedAt } }) =>
          currentstatus === "open" && isToday(new Date(modifiedAt))
      ).length;
      /* This Month Open Deals */
      result.MonthOpenDeals = deals.filter(
        ({ document: { currentstatus, modifiedAt } }) =>
          currentstatus === "open" && isThisMonth(new Date(modifiedAt))
      ).length;

      /* Modifying dates in deals */

      deals = deals.map(({ document }) => document);
      var groupArray = require("group-array");
      const groupByDate = groupArray(
        deals.filter(({ currentstatus }) => currentstatus === "won"),
        "modifiedAt"
      );
      let revenueChart = [];
      const groupByDateKeys = Object.keys(groupByDate);
      let sum = 0;
      groupByDateKeys.forEach((date) => {
        groupByDate[date].forEach(({ dealPrice }) => (sum += dealPrice * 1));
        const e = date.split(" ");
        revenueChart.push({
          month: e[1] + " " + e[2],
          sales: sum,
        });
        sum = 0;
      });
      setRevenueChartData([...revenueChart]);

      setResult({ ...result });
    }

    fetchData();
  }, [getLocalStorageItem("bid")]);

  /** Popover Logic */
  const [SearchText, setSearchText] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  /* Detect click outside */
  const [openSearch, setOpenSearch] = useState(false);
  const outsideClickRef = useOnclickOutside(() => {
    setOpenSearch(false);
  });
  useEffect(
    () => setOpenSearch(SearchText === "" ? false : true),
    [SearchText]
  );

  const [DayAppointments, setDayAppointments] = useState([{}]);
  const [CalendarDate, setCalendarDate] = useState(
    new Date().toLocaleString().slice(0, 10)
  );
  useEffect(() => {
    async function fetchData() {
      const appointmentsArray = await GetAppointments();

      const FilteredArray = appointmentsArray.filter(
        (appointment) =>
          appointment.startDate.toDate().toLocaleString().slice(0, 10) ===
          CalendarDate
      );

      setDayAppointments(FilteredArray);
    }
    fetchData();
  }, [CalendarDate]);

  return (
    <Fragment>
      {/* {Object.keys(Result).length !== 0 && ( */}
      <div className="global-body-container dashboard-page">
        <div className="dashboard-header">
          <div className="dashboard-welcome-container">
            <div className="dashboard-title">
              <p className="custom-heading"> Dashboard</p>
            </div>
            <div className="welcome-message">Welcome to LandBook</div>
          </div>
          <div className="dropdown custom-dropdown d-none">
            <div
              className="btn btn-sm btn-primary light d-flex align-items-center svg-btn"
              data-toggle="dropdown"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path
                    d="M22.4281 2.856H21.8681V1.428C21.8681 0.56 21.2801 0 20.4401 0C19.6001 0 19.0121 0.56 19.0121 1.428V2.856H9.71606V1.428C9.71606 0.56 9.15606 0 8.28806 0C7.42006 0 6.86006 0.56 6.86006 1.428V2.856H5.57206C2.85606 2.856 0.560059 5.152 0.560059 7.868V23.016C0.560059 25.732 2.85606 28.028 5.57206 28.028H22.4281C25.1441 28.028 27.4401 25.732 27.4401 23.016V7.868C27.4401 5.152 25.1441 2.856 22.4281 2.856ZM5.57206 5.712H22.4281C23.5761 5.712 24.5841 6.72 24.5841 7.868V9.856H3.41606V7.868C3.41606 6.72 4.42406 5.712 5.57206 5.712ZM22.4281 25.144H5.57206C4.42406 25.144 3.41606 24.136 3.41606 22.988V12.712H24.5561V22.988C24.5841 24.136 23.5761 25.144 22.4281 25.144Z"
                    fill={Colors.themeColorSmallAfter}
                  ></path>
                </g>
              </svg>
              <div className="text-left ml-3">
                <span className="d-block">Filter Periode</span>
                <small className="d-block">4 June 2020 - 4 July 2020</small>
              </div>
              <i className="fa fa-angle-down scale5 ml-3"></i>
            </div>
            <div className="dropdown-menu dropdown-menu-right">
              <a className="dropdown-item" href="#">
                4 June 2020 - 4 July 2020
              </a>
              <a className="dropdown-item" href="#">
                5 july 2020 - 4 Aug 2020
              </a>
            </div>
          </div>
        </div>

        <div className="dashboard-top-row">
          <Link to="/user/properties" className="dashboard-property-card">
            <div className="property-card-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="70"
                height="70"
                viewBox="0 0 90 90"
              >
                <g transform="translate(-13136 130)">
                  <g transform="translate(12701.632 -420.368)">
                    <circle
                      cx="45"
                      cy="45"
                      r="45"
                      transform="translate(434.368 290.368)"
                      fill="#fff"
                      opacity="0.2"
                    />
                    <path
                      d="M22.688,38.89H32.96a6.884,6.884,0,0,0,6.4-4.29h9.407a2.488,2.488,0,0,0,2.508-2.46V17.448a2.434,2.434,0,0,0-.9-1.888L37.336,4.87a2.548,2.548,0,0,0-3.217,0L31.232,7.236l-3.41,2.8,0,0-6.741,5.527a2.434,2.434,0,0,0-.9,1.888V32.136a2.487,2.487,0,0,0,2.5,2.46H39.357a6.877,6.877,0,0,1-6.4,4.29H6.88A6.825,6.825,0,0,1,0,32.136V17.444a6.685,6.685,0,0,1,2.467-5.179L15.51,1.572a6.978,6.978,0,0,1,8.824,0l3.492,2.864-3.411,2.8L21.529,4.867a2.546,2.546,0,0,0-3.217,0L5.272,15.556a2.434,2.434,0,0,0-.9,1.888V32.136A2.488,2.488,0,0,0,6.88,34.6h9.407a6.63,6.63,0,0,1-.479-2.46V17.444a6.685,6.685,0,0,1,2.467-5.179l6.137-5.033,0,0L27.822,4.44h0l3.492-2.865a6.977,6.977,0,0,1,8.823,0l13.04,10.69a6.689,6.689,0,0,1,2.471,5.179v14.7a6.825,6.825,0,0,1-6.88,6.75Zm-.007,0h0ZM32.956,34.6a2.488,2.488,0,0,0,2.508-2.46V17.444a2.434,2.434,0,0,0-.9-1.888l-6.739-5.525,3.411-2.8,6.137,5.029a6.686,6.686,0,0,1,2.466,5.179V32.136a6.615,6.615,0,0,1-.479,2.46Zm-10.268,0h0Z"
                      transform="translate(451.283 315.925)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
            </div>

            <div className="property-card-content">
              {
                <div className="property-counter">
                  {Result?.properties || 0}
                </div>
              }

              <div className="property-description">Total Properties</div>
              <div className="property-description-small">(All Time)</div>
            </div>
          </Link>

          <div className="won-deals-card">
            <div className="won-deals-card-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="70"
                height="70"
                viewBox="0 0 90 90"
              >
                <g transform="translate(-619.422 -272.629)">
                  <rect
                    width="90"
                    height="90"
                    rx="44"
                    transform="translate(619.422 272.629)"
                    fill="#4E36A8"
                    opacity="0.2"
                  />
                  <path
                    d="M24.253,53.732a2.318,2.318,0,0,1-.885-1.468,3.5,3.5,0,0,1-.983.2,3.442,3.442,0,0,1-2.36-.979,3.03,3.03,0,0,1-.885-1.762,1.25,1.25,0,0,1-.59.1,3.443,3.443,0,0,1-2.36-.979,3.378,3.378,0,0,1-.984-2.056h-.2a3.443,3.443,0,0,1-2.36-.979,3.161,3.161,0,0,1-.2-4.306L8.222,35.625c-.2.1-.3.1-.492.2a1.25,1.25,0,0,1-.59.1,1.467,1.467,0,0,1-.885-.2l-5.213-2.74a2.287,2.287,0,0,1-.984-1.174,1.891,1.891,0,0,1,.2-1.468l7.475-13.9a1.941,1.941,0,0,1,2.656-.783L15.6,18.5a1.906,1.906,0,0,1,.983,1.174,1.946,1.946,0,0,1-.2,1.468l-.1.1a2.848,2.848,0,0,0,2.262.685c1.475-.2,6.59-.783,8.753.1.1,0,.1.1.2.1s.2-.1.295-.1c2.164-.881,7.278-.293,8.753-.1a3.02,3.02,0,0,0,2.163-.685l-.1-.1a1.556,1.556,0,0,1-.2-1.468A2.289,2.289,0,0,1,39.4,18.5l5.212-2.74a1.576,1.576,0,0,1,1.475-.2,2.3,2.3,0,0,1,1.18.979l7.475,13.8h0c.295.391.295.979.688,1.37a2.289,2.289,0,0,1-.984,1.174l-5.212,2.74a2.354,2.354,0,0,1-.885.2,1.256,1.256,0,0,1-.59-.1,1.985,1.985,0,0,1-.787-.391L45.1,37.289a3.5,3.5,0,0,1,.492,3.817,4.065,4.065,0,0,1-2.458,1.957,3.141,3.141,0,0,1-.885,2.839A3.716,3.716,0,0,1,39.4,46.978a3.465,3.465,0,0,1-4.032,2.936,3.394,3.394,0,0,1-.984,1.957,4.115,4.115,0,0,1-2.852,1.077,4.476,4.476,0,0,1-1.574-.294,1.716,1.716,0,0,1-.393.49l-.59.587a3.2,3.2,0,0,1-2.36.979A3.443,3.443,0,0,1,24.253,53.732Zm1.966-3.817-.3.294a.1.1,0,0,0-.1.1l-.393.391a1.236,1.236,0,0,0,0,1.762,1.372,1.372,0,0,0,1.868,0l.59-.587c0-.1,0-.1.1-.293l.295-.294a1.208,1.208,0,0,0-.295-1.37,1.071,1.071,0,0,0-.885-.392A1.468,1.468,0,0,0,26.219,49.914Zm2.754-1.468a3.179,3.179,0,0,1,.984,2.251,2.34,2.34,0,0,0,2.459-.293c.59-.587.3-1.174,0-1.664L30.94,47.663a.98.98,0,1,1,1.18-1.566l1.574,1.174a.1.1,0,0,1,.1.1,1.9,1.9,0,0,0,2.754.1c.393-.391.3-.881-.2-1.37l-2.655-1.86a1.031,1.031,0,0,1-.2-1.37,1.044,1.044,0,0,1,1.377-.2l2.754,1.86.1.1a1.757,1.757,0,0,0,2.557.1,1.175,1.175,0,0,0,0-1.762l-.1-.1-3.541-2.251a.96.96,0,0,1-.3-1.37.97.97,0,0,1,1.377-.294L41.562,41.4a2.2,2.2,0,0,0,1.77-1.077c.688-1.174-.59-2.153-1.377-2.74L30.547,30.536c-1.082,2.447-2.164,3.719-3.541,4.306-1.279.587-2.852.49-4.819-.293l-.787-.294.1-.978c1.082-4.013,2.164-7.634,4.032-9.787a27.676,27.676,0,0,0-6.786.2A4.793,4.793,0,0,1,15.3,22.8l-6,11.059,4.327,6.166a3.276,3.276,0,0,1,4.623,0A2.807,2.807,0,0,1,19.04,41.3a3.32,3.32,0,0,1,3.737.587,3.141,3.141,0,0,1,.885,2.839,3.376,3.376,0,0,1,1.77.881,3.587,3.587,0,0,1,.885,1.957q.184-.018.368-.018A3.216,3.216,0,0,1,28.973,48.446Zm-6.59-1.273L21.2,48.348a1.357,1.357,0,0,0,0,1.86,1.25,1.25,0,0,0,1.77,0l.787-.783a.1.1,0,0,0,.1-.1l.393-.391a1.237,1.237,0,0,0,0-1.762,1.373,1.373,0,0,0-1.869,0Zm-2.557-3.915-2.36,2.349a1.356,1.356,0,0,0,0,1.86,1.251,1.251,0,0,0,1.77,0l2.36-2.349a1.356,1.356,0,0,0,0-1.86,1.071,1.071,0,0,0-.885-.392A1.206,1.206,0,0,0,19.826,43.259ZM15.2,41.4l-1.18,1.174a1.322,1.322,0,0,0,1.77,1.957l1.278-1.273a1.354,1.354,0,0,0,0-1.859,1.371,1.371,0,0,0-1.868,0Zm27.834-5.382c.1,0,.1.1.2.1L45.4,33.668,39.6,22.9a4.537,4.537,0,0,1-3.344.881c-4.032-.489-6.786-.391-7.769,0-2.262,1.077-3.541,4.992-4.721,9.3a3.339,3.339,0,0,0,2.557.1c1.082-.489,1.967-1.762,2.951-4.306l.393-1.076Zm-41.11-4.8,5.212,2.74,7.475-13.8L9.4,17.421ZM40.382,20.16l7.475,13.8,5.212-2.74-7.475-13.8Zm7.277,9.984a1.475,1.475,0,1,1,1.475,1.468A1.471,1.471,0,0,1,47.659,30.145Zm-43.274,0A1.475,1.475,0,1,1,5.86,31.613,1.471,1.471,0,0,1,4.385,30.145ZM29.366,17.911,27.4,11.255l-1.967,6.655a.976.976,0,0,1-.983.685.931.931,0,0,1-.885-.783L23.17,15.66H21.6a.979.979,0,1,1,0-1.957h1.18l-.393-1.957h-1.77a.979.979,0,1,1,0-1.957H21.99L21.6,8.026a1,1,0,0,1,1.967-.391l1.18,5.97,1.77-6.068a1.184,1.184,0,0,1,.983-.685.977.977,0,0,1,.983.685l1.77,6.068,1.18-5.97a1,1,0,0,1,1.967.391l-.393,1.762h1.377a.979.979,0,1,1,0,1.957h-1.77L32.219,13.7H33.4a.979.979,0,1,1,0,1.957h-1.77l-.393,2.153a.944.944,0,0,1-.885.783A.977.977,0,0,1,29.366,17.911ZM14.909,14.877a15.974,15.974,0,0,1-.2-2.153,12.786,12.786,0,0,1,25.571,0,14.563,14.563,0,0,1-.2,2.153.957.957,0,0,1-.984.783h-.2a1.074,1.074,0,0,1-.787-1.174,10.709,10.709,0,0,0,.2-1.762,10.819,10.819,0,0,0-21.637,0c0,.587.1,1.174.1,1.762a1.016,1.016,0,0,1-.787,1.174.769.769,0,0,1-.153.015A1,1,0,0,1,14.909,14.877Z"
                    transform="translate(636.525 289.46)"
                    fill="#4E36A8"
                  />
                </g>
              </svg>
            </div>
            <div className="won-deals-card-content">
              <div className="custom-heading">Won Deals</div>
              <div className="today-this-month-container">
                <Link to={"/user/deals"} className="today-container">
                  <div className="today-title">Today</div>

                  <div className="today-result">
                    {Result?.TodayWonDeals || 0}
                  </div>
                </Link>

                <Link to={"/user/deals"} className="this-month-container">
                  <div className="this-month-title">This Month</div>
                  <div className="this-month-result">
                    {/* {Result?.MonthWonDeals
                      ? Counterup(
                          "won-deals-this-month",
                          0,
                          Result?.MonthWonDeals,
                          2000
                        )
                      : 0} */}

                    {Result?.MonthWonDeals || 0}
                  </div>
                </Link>
              </div>
            </div>
          </div>

          <div className="lost-archived-deals-card">
            <div className="lost-archived-deals-card-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="70"
                height="70"
                viewBox="0 0 90 90"
              >
                <g transform="translate(-1056 -284)">
                  <rect
                    width="90"
                    height="90"
                    rx="44"
                    transform="translate(1056 284)"
                    fill="#4E36A8"
                    opacity="0.2"
                  />
                  <path
                    d="M-11263.747,484.438a2.351,2.351,0,0,1-.884-1.487,3.424,3.424,0,0,1-.983.2,3.427,3.427,0,0,1-2.362-.99,3.085,3.085,0,0,1-.884-1.785,1.263,1.263,0,0,1-.592.1,3.425,3.425,0,0,1-2.36-.99,3.443,3.443,0,0,1-.982-2.084h-.2a3.427,3.427,0,0,1-2.362-.99,3.234,3.234,0,0,1-.2-4.363l-4.229-5.95c-.2.1-.295.1-.49.2a1.231,1.231,0,0,1-.592.1,1.448,1.448,0,0,1-.884-.2l-5.213-2.778a2.3,2.3,0,0,1-.983-1.188,1.947,1.947,0,0,1,.2-1.49l7.477-14.078a1.925,1.925,0,0,1,2.654-.8l5.213,2.876a1.933,1.933,0,0,1,.982,1.191,1.99,1.99,0,0,1-.2,1.487l-.1.1a2.81,2.81,0,0,0,2.261.695c1.476-.2,6.592-.792,8.753.1.1,0,.1.1.2.1s.2-.1.294-.1c2.162-.893,7.278-.3,8.754-.1a2.978,2.978,0,0,0,2.161-.695l-.1-.1a1.6,1.6,0,0,1-.2-1.487,2.332,2.332,0,0,1,.982-1.191l5.213-2.776a1.549,1.549,0,0,1,1.476-.2,2.291,2.291,0,0,1,1.182.99l7.474,13.984v0c.294.4.294.993.688,1.389a2.306,2.306,0,0,1-.983,1.191l-5.213,2.776a2.3,2.3,0,0,1-.884.2,1.263,1.263,0,0,1-.592-.1,1.986,1.986,0,0,1-.785-.4l-1.869,1.983a3.587,3.587,0,0,1,.49,3.869,4.076,4.076,0,0,1-2.459,1.983,3.205,3.205,0,0,1-.884,2.876,3.693,3.693,0,0,1-2.854,1.088,3.649,3.649,0,0,1-.784,1.785,3.566,3.566,0,0,1-3.247,1.191,3.46,3.46,0,0,1-.982,1.983,4.084,4.084,0,0,1-2.853,1.091,4.435,4.435,0,0,1-1.575-.3,1.727,1.727,0,0,1-.392.5l-.592.594a3.179,3.179,0,0,1-2.359.993A3.411,3.411,0,0,1-11263.747,484.438Zm1.966-3.866-.294.3a.1.1,0,0,0-.1.1l-.394.4a1.267,1.267,0,0,0,0,1.785,1.359,1.359,0,0,0,1.869,0l.59-.594c0-.1,0-.1.1-.3l.295-.3a1.236,1.236,0,0,0-.295-1.389,1.059,1.059,0,0,0-.887-.4A1.463,1.463,0,0,0-11261.781,480.572Zm2.754-1.487a3.228,3.228,0,0,1,.983,2.279,2.315,2.315,0,0,0,2.459-.3c.592-.6.3-1.191,0-1.688l-1.474-1.091a1.07,1.07,0,0,1-.2-1.386,1.034,1.034,0,0,1,1.377-.2l1.575,1.188a.1.1,0,0,1,.1.1,1.883,1.883,0,0,0,2.754.1c.394-.4.295-.893-.2-1.386l-2.654-1.886a1.056,1.056,0,0,1-.2-1.389,1.037,1.037,0,0,1,1.377-.2l2.753,1.886.1.1a1.743,1.743,0,0,0,2.558.1,1.2,1.2,0,0,0,0-1.785l-.1-.1-3.541-2.279a.98.98,0,0,1-.295-1.389.961.961,0,0,1,1.377-.3l3.836,2.477a2.2,2.2,0,0,0,1.771-1.091c.688-1.188-.59-2.181-1.377-2.776l-11.408-7.138c-1.082,2.477-2.164,3.766-3.541,4.36-1.28.6-2.853.5-4.819-.3l-.787-.3.1-.99c1.08-4.067,2.162-7.735,4.031-9.917a27.346,27.346,0,0,0-6.784.2,4.749,4.749,0,0,1-3.442-.893l-6,11.205,4.326,6.249a3.242,3.242,0,0,1,4.623,0,2.823,2.823,0,0,1,.787,1.289,3.281,3.281,0,0,1,3.737.594,3.2,3.2,0,0,1,.884,2.876,3.332,3.332,0,0,1,1.771.893,3.657,3.657,0,0,1,.887,1.983,3.167,3.167,0,0,1,.368-.02A3.191,3.191,0,0,1-11259.027,479.085Zm-6.59-1.289-1.181,1.188a1.393,1.393,0,0,0,0,1.886,1.242,1.242,0,0,0,1.771,0l.787-.8a.1.1,0,0,0,.1-.1l.394-.4a1.264,1.264,0,0,0,0-1.782,1.311,1.311,0,0,0-.935-.373A1.31,1.31,0,0,0-11265.617,477.8Zm-2.558-3.967-2.36,2.379a1.39,1.39,0,0,0,0,1.883,1.239,1.239,0,0,0,1.771,0l2.359-2.379a1.383,1.383,0,0,0,0-1.883,1.059,1.059,0,0,0-.884-.4A1.2,1.2,0,0,0-11268.175,473.83Zm-4.62-1.886-1.182,1.191a1.383,1.383,0,0,0,0,1.883,1.343,1.343,0,0,0,1.771.1l1.277-1.289a1.385,1.385,0,0,0,0-1.886,1.311,1.311,0,0,0-.935-.37A1.314,1.314,0,0,0-11272.795,471.944Zm27.833-5.453c.1,0,.1.1.2.1l2.165-2.48-5.8-10.907a4.5,4.5,0,0,1-3.343.893c-4.034-.5-6.787-.4-7.771,0-2.264,1.091-3.541,5.057-4.72,9.42a3.293,3.293,0,0,0,2.556.1c1.082-.494,1.966-1.782,2.952-4.363l.391-1.091Zm-2.657-16.065,7.477,13.984,5.212-2.778-7.476-13.981Zm-38.454,11.205,5.213,2.778,7.476-13.984-5.213-2.776Zm45.731-1.088a1.482,1.482,0,0,1,1.477-1.49,1.482,1.482,0,0,1,1.476,1.49,1.481,1.481,0,0,1-1.476,1.487A1.481,1.481,0,0,1-11240.342,460.543Zm-43.272,0a1.482,1.482,0,0,1,1.476-1.49,1.481,1.481,0,0,1,1.474,1.49,1.481,1.481,0,0,1-1.474,1.487A1.481,1.481,0,0,1-11283.614,460.543Zm28.168-12.638-4.839-4.9-4.839,4.9a.468.468,0,0,1-.334.138.469.469,0,0,1-.331-.138.48.48,0,0,1,0-.674l4.838-4.9-4.838-4.9a.48.48,0,0,1,0-.674.465.465,0,0,1,.665,0l4.839,4.9,4.839-4.9a.465.465,0,0,1,.665,0,.48.48,0,0,1,0,.674l-4.838,4.9,4.838,4.9a.48.48,0,0,1,0,.674.469.469,0,0,1-.331.138A.468.468,0,0,1-11255.446,447.906Zm-17.646-2.833a16.621,16.621,0,0,1-.2-2.181A12.812,12.812,0,0,1-11260.5,430a12.812,12.812,0,0,1,12.787,12.89,14.809,14.809,0,0,1-.2,2.181.957.957,0,0,1-.982.792h-.2a1.086,1.086,0,0,1-.785-1.188,11.242,11.242,0,0,0,.2-1.785,10.83,10.83,0,0,0-10.818-10.907,10.832,10.832,0,0,0-10.819,10.907c0,.594.1,1.188.1,1.785a1.025,1.025,0,0,1-.788,1.188.685.685,0,0,1-.15.017A1.006,1.006,0,0,1-11273.093,445.073Z"
                    transform="translate(12361.285 -128.356)"
                    fill="#4E36A8"
                  />
                </g>
              </svg>
            </div>
            <div className="lost-archived-deals-card-content">
              <div className="custom-heading">Lost | Archived Deals</div>
              <div className="today-this-month-container">
                <Link to={"/user/deals"} className="today-container">
                  <div className="today-title">Today</div>
                  <div className="today-result" id="won-deals-today">
                    {Result?.TodayLostDeals || 0}
                    {/* {Result?.TodayLostDeals
                      ? Counterup(
                          "won-deals-today",
                          0,
                          Result?.TodayLostDeals,
                          2000
                        )
                      : 0} */}
                    |
                    {/* {Result?.TodayAutoLostDeals
                        ? Counterup(
                            "total-deals-today",
                            0,
                            Result?.TodayAutoLostDeals,
                            2000
                          )
                        : 0} */}
                    {Result?.TodayAutoLostDeals || 0}
                  </div>
                </Link>

                <Link to={"/user/deals"} className="this-month-container">
                  <div className="this-month-title">This Month</div>
                  <div className="this-month-result" id="lost-deals-this-month">
                    {Result?.MonthLostDeals || 0}|
                    <span id="auto-lost-deals-this-month">
                      {/* {Result?.MonthAutoLostDeals
                        ? Counterup(
                            "auto-lost-deals-this-month",
                            0,
                            Result?.MonthAutoLostDeals,
                            2000
                          )\

                        : 0} */}
                      {Result?.MonthAutoLostDeals || 0}
                    </span>
                  </div>
                </Link>
              </div>
            </div>
          </div>

          <div className="open-deals-card">
            <div className="open-deals-card-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="70"
                height="70"
                viewBox="0 0 90 90"
              >
                <g transform="translate(-1489 -286)">
                  <rect
                    width="90"
                    height="90"
                    rx="44"
                    transform="translate(1489 286)"
                    fill="#4E36A8"
                    opacity="0.2"
                  />
                  <g transform="translate(-10926 -389)">
                    <g transform="translate(12437 702)">
                      <g transform="translate(0 0)">
                        <path
                          d="M16.728-387.481l-.871,1.689H10v31.73l18.807-.018,18.807-.026.293-.978c.169-.542,1.84-6.177,3.733-12.532s3.529-11.866,3.644-12.248l.2-.684H17.324l-1.573,5.706c-.871,3.147-1.875,6.773-2.24,8.071l-.658,2.355v-9.27l-.009-9.261h4.7l.871-1.689.871-1.689,5.324.026,5.315.018.862,1.662.853,1.671H50.085v-2.844l-8.373-.018-8.373-.026-.862-1.644-.871-1.644-7-.018-7-.026Zm34.957,9.83c0,.026-.578,1.973-1.28,4.328s-2.089,7.013-3.075,10.345l-1.814,6.071H29.536c-8.79,0-15.98-.018-15.98-.045s1.04-3.635,2.32-8.017,2.613-9.021,2.986-10.292.684-2.338.711-2.382C19.617-377.714,51.685-377.731,51.685-377.652Z"
                          transform="translate(-10 389.17)"
                          fill="#4E36A8"
                        />
                        <path
                          d="M17.295-389.671l7.31.028,7.3.019,1.011,1.909.723,1.379,8.071.026,8.872.019v3.843H31.336l-.992-1.944-.721-1.391L24.61-385.8l-5.018-.025-1.741,3.376H13.345l.008,8.761v5.621c.472-1.695,1.226-4.42,1.91-6.889l.006-.021,1.674-6.072H56.159l-.4,1.327c-.047.157-.353,1.186-.817,2.744-.678,2.282-1.708,5.745-2.828,9.5-.725,2.435-1.418,4.764-2.006,6.741-.94,3.161-1.62,5.447-1.728,5.794l-.4,1.331-19.178.027L9.5-353.562v-32.73h6.052Zm14.01,1.045-6.7-.017-6.7-.025-1.742,3.376H10.5v30.729l18.306-.017,18.435-.026.188-.627c.1-.331.784-2.619,1.725-5.785.588-1.978,1.281-4.307,2.006-6.742,1.12-3.758,2.149-7.221,2.827-9.5.464-1.559.77-2.59.817-2.747l.012-.039H17.7l-1.478,5.36c-.877,3.167-1.871,6.756-2.234,8.052l-.658,2.355-.982-.134v-9.27l-.009-9.761h4.9l1.743-3.379,5.631.028,5.617.019,1,1.931.715,1.4H49.585v-1.846l-7.874-.017-8.675-.027-1-1.911ZM37.722-378.2c3.815,0,7.264,0,9.711.013,1.34,0,2.382.01,3.1.016.378,0,.668.007.863.011l.236.006a.506.506,0,0,1,.556.506c0,.1,0,.107-1.3,4.471-.729,2.448-2.1,7.046-3.075,10.345l-1.92,6.429H29.536c-4.351,0-8.36,0-11.288-.012-1.48,0-2.635-.009-3.435-.014-.411,0-.727-.006-.939-.009l-.251,0-.077,0a.5.5,0,0,1-.491-.5,23.207,23.207,0,0,1,.7-2.514c.28-.97.866-2.992,1.64-5.643,1.146-3.958,2.594-8.959,2.987-10.293a21.824,21.824,0,0,1,.763-2.5l0-.005a.563.563,0,0,1,.522-.243l.327-.007c.273,0,.677-.008,1.2-.012.994-.007,2.411-.014,4.213-.019C28.8-378.2,33.282-378.2,37.722-378.2Zm13.3,1.034c-1.678-.021-6.664-.034-13.3-.034-8.677,0-16.159.021-17.782.048-.12.391-.338,1.127-.6,2.033-.393,1.336-1.841,6.335-2.987,10.293-.976,3.339-1.8,6.191-2.144,7.392,1.9.018,7.937.031,15.324.031H45.144l1.707-5.714c.976-3.3,2.346-7.9,3.075-10.345C50.526-375.479,50.854-376.585,51.026-377.17Z"
                          transform="translate(-10 389.17)"
                          fill="#ccfbda"
                        />
                      </g>
                    </g>
                    <path
                      d="M13.2,9.462H12.82a2.807,2.807,0,0,0-.428.033L8.347,6.462l.969-.928A.574.574,0,0,0,8.522,4.7L6.127,7A.573.573,0,0,1,5.25,6.92a.617.617,0,0,1,.1-.766l2.7-2.542a1.742,1.742,0,0,1,1.937-.284l1.329.665a2.885,2.885,0,0,0,1.283.3H13.2a.574.574,0,1,0,0-1.148H12.6a1.733,1.733,0,0,1-.77-.181L10.5,2.3a2.911,2.911,0,0,0-3.238.475L6.9,3.11l-.4-.366A2.894,2.894,0,0,0,3.278,2.3L1.95,2.965a1.737,1.737,0,0,1-.771.181H.574a.574.574,0,1,0,0,1.148H1.18a2.9,2.9,0,0,0,1.284-.3l1.329-.665a1.785,1.785,0,0,1,1.937.265l.337.307L4.548,5.33a1.768,1.768,0,0,0-.228,2.261,1.867,1.867,0,0,0,1.4.723,1.709,1.709,0,0,0,1.208-.5l.577-.553L11.15,10,7.592,12.664a1.151,1.151,0,0,1-1.418-.006l-3.5-2.622A2.886,2.886,0,0,0,.956,9.461H.573a.574.574,0,0,0,0,1.148H.956a1.733,1.733,0,0,1,1.033.344L5.478,13.57a2.3,2.3,0,0,0,1.413.486,2.274,2.274,0,0,0,1.4-.479l3.5-2.622a1.73,1.73,0,0,1,1.033-.344H13.2a.574.574,0,1,0,0-1.148Z"
                      transform="translate(12452.856 716.525)"
                      fill="#4E36A8"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div className="open-deals-card-content">
              <div className="custom-heading">Open Deals</div>
              <div className="today-this-month-container">
                <Link to={"/user/deals"} className="today-container">
                  <div className="today-title">Today</div>
                  <div className="today-result" id="open-deals-this-today">
                    {/* {Result?.TodayOpenDeals
                      ? Counterup(
                          "open-deals-this-today",
                          0,
                          Result?.TodayOpenDeals,
                          2000
                        )
                      : 0} */}
                    {Result?.TodayOpenDeals || 0}
                  </div>
                </Link>

                <Link to={"/user/deals"} className="this-month-container">
                  <div className="this-month-title">This Month</div>
                  <div className="this-month-result">
                    {Result?.MonthOpenDeals || 0}
                    {/* {Result?.TodayOpenDeals ? (
                      <NumberCountUp end={Result?.TodayOpenDeals} />
                    ) : (
                      0
                    )} */}
                    {/* 
                    {Result?.TodayOpenDeals
                      ? Counterup(
                          "open-deals-this-month",
                          0,
                          Result?.TodayOpenDeals,
                          2000
                        )
                      : 0} */}
                  </div>
                </Link>
              </div>
            </div>
          </div>

          <Link to="/user/leads" className="card-body LeadsContainer">
            <div className="leadsSvg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="85"
                height="85"
                viewBox="0 0 108 108"
              >
                <defs>
                  <filter
                    id="a"
                    x="0"
                    y="0"
                    width="108"
                    height="108"
                    filterUnits="userSpaceOnUse"
                  >
                    <feOffset dy="3" input="SourceAlpha" />
                    <feGaussianBlur stdDeviation="3" result="b" />
                    <feFlood floodOpacity="0.161" />
                    <feComposite operator="in" in2="b" />
                    <feComposite in="SourceGraphic" />
                  </filter>
                </defs>
                <g transform="translate(9.001 6)">
                  <g transform="translate(0)">
                    <g transform="matrix(1, 0, 0, 1, -9, -6)" filter="url(#a)">
                      <circle
                        cx="45"
                        cy="45"
                        r="45"
                        transform="translate(9 6)"
                        fill="#4E36A8"
                        opacity="0.14"
                      />
                    </g>
                  </g>
                  <g transform="translate(27.126 21.868)">
                    <g transform="translate(0.759 8.132)">
                      <g transform="translate(0)">
                        <path
                          d="M101.367,97.1a1.8,1.8,0,0,0-1.6-.958H94.639a5.149,5.149,0,0,0-10.139,0H79.3a3.976,3.976,0,1,0-6.659,0H68.4a1.807,1.807,0,0,0-1.5,2.816l12.125,18.031v10.236a.9.9,0,0,0,1.264.828l8.313-3.62a.9.9,0,0,0,.543-.828v-6.616L101.271,98.96A1.8,1.8,0,0,0,101.367,97.1Zm-11.8-3.4a3.349,3.349,0,0,1,3.218,2.44H86.351A3.348,3.348,0,0,1,89.569,93.7Zm-13.6-1.9A2.169,2.169,0,1,1,73.8,93.976,2.171,2.171,0,0,1,75.97,91.807Zm11.523,24.4a.9.9,0,0,0-.154.5v6.3l-6.506,2.833v-8.229H84.1a.9.9,0,1,0,0-1.807H80.411l-9.094-13.523H89.569a.9.9,0,0,0,0-1.807H70.1l-1.7-2.53H99.772Z"
                          transform="translate(-66.593 -90)"
                          fill="#4E36A8"
                        />
                      </g>
                    </g>
                    <g transform="translate(17.36)">
                      <path
                        d="M254.3,0a3.976,3.976,0,1,0,3.976,3.976A3.98,3.98,0,0,0,254.3,0Zm0,6.144a2.169,2.169,0,1,1,2.169-2.169A2.171,2.171,0,0,1,254.3,6.144Z"
                        transform="translate(-250.324)"
                        fill="#4E36A8"
                      />
                    </g>
                    <g transform="translate(30.089 4.367)">
                      <path
                        d="M392.1,48.333a.9.9,0,0,0-.9.9v5.135a.9.9,0,1,0,1.807,0V49.237A.9.9,0,0,0,392.1,48.333Z"
                        transform="translate(-391.197 -48.333)"
                        fill="#4E36A8"
                      />
                    </g>
                    <g transform="translate(30.089 1.401)">
                      <path
                        d="M392.739,15.765A.9.9,0,1,0,393,16.4.911.911,0,0,0,392.739,15.765Z"
                        transform="translate(-391.197 -15.5)"
                        fill="#4E36A8"
                      />
                    </g>
                    <g transform="translate(12.305 1.152)">
                      <path
                        d="M195.279,12.755a.9.9,0,0,0-.9.9v3.7a.9.9,0,1,0,1.807,0v-3.7A.9.9,0,0,0,195.279,12.755Z"
                        transform="translate(-194.375 -12.755)"
                        fill="#4E36A8"
                      />
                    </g>
                    <g transform="translate(0)">
                      <path
                        d="M59.1,0a.9.9,0,0,0-.9.9V6.792a.9.9,0,0,0,1.807,0V.9A.9.9,0,0,0,59.1,0Z"
                        transform="translate(-58.197 0)"
                        fill="#4E36A8"
                      />
                    </g>
                    <g transform="translate(0 9.277)">
                      <path
                        d="M59.739,102.935a.9.9,0,1,0,.265.639A.907.907,0,0,0,59.739,102.935Z"
                        transform="translate(-58.197 -102.67)"
                        fill="#4E36A8"
                      />
                    </g>
                    <g transform="translate(26.849 18.613)">
                      <g transform="translate(0)">
                        <path
                          d="M356.889,206.265a.9.9,0,1,0,.265.639A.91.91,0,0,0,356.889,206.265Z"
                          transform="translate(-355.347 -206)"
                          fill="#4E36A8"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div className="leadsContentContainer">
              <div className="leadsContentLeftContainer">
                <div className="leadsTitle custom-heading">Total Clients</div>
                <div
                  style={{
                    backgroundColor:
                      Result?.TotalLeads > 0 ? "#4e36a8" : "#CCCCCC",
                  }}
                  className="horizontalLine"
                ></div>
                <div className="leadsAllTimeText">(All Time)</div>
              </div>

              <div className="leadsContentRightContainer">
                <div
                  className="leadsCount"
                  style={{
                    fontSize: 40,
                    marginLeft: 13,
                    marginBottom: 13,
                  }}
                >
                  {Result?.TotalLeads || 0}
                </div>
              </div>
            </div>
          </Link>
        </div>

        <div className="row">
          <div className="col-xxl-9 col-xl-8 col-lg-12 col-md-12 col-sm-12 leadsTotalRevenue">
            <div className="row-xl-6 row-lg-6 row-sm-12 TotalRevenueCardRow">
              <h2 className="total-revenue-chart-title custom-heading">
                Total Revenue
              </h2>

              {RevenueChartData?.length === 0 && (
                <div className="total-revenue-content">
                  <img
                    src={NoRevenueChart}
                    alt="Revenue"
                    style={{
                      width: "50px",
                      opacity: "0.5",
                    }}
                  />
                  <p
                    style={{
                      color: "grey",
                      fontSize: "12px",
                    }}
                  >
                    No Data Found
                  </p>
                </div>
              )}
              <SyncRevenueChart
                id={"revenueBarChart"}
                ChartData={RevenueChartData}
              />
            </div>
            <div className="row-xl-6 row-lg-6 row-sm-12 openWonLostDealsPieChart">
              <div className="row-xl-6 row-lg-6 row-sm-12">
                <div className="widget-stat card DealsCardContainer">
                  <h2 className="deals-chart-title custom-heading">Deals</h2>
                  <div
                    className="card-body DealsContainer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      contain: "content",
                      padding: "0px",
                    }}
                  >
                    {(Result?.TotalOpenDeals || 0) === 0 &&
                    (Result?.TotalWonDeals || 0) === 0 &&
                    (Result?.TotalLostDeals || 0) === 0 &&
                    (Result?.TotalAutoLostDeals || 0) === 0 ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={NoPieChart}
                          alt="Revenue"
                          style={{
                            width: "50px",
                            opacity: "0.5",
                          }}
                        />
                        <p style={{ color: "grey", fontSize: "12px" }}>
                          No Data Found
                        </p>
                      </div>
                    ) : (
                      <SyncPieChart
                        id={"SyncPieChart"}
                        TotalOpenDeals={Result.TotalOpenDeals}
                        TotalWonDeals={Result.TotalWonDeals}
                        TotalLostDeals={Result.TotalLostDeals}
                        TotalAutoLostDeals={Result.TotalAutoLostDeals}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xxl-3 col-xl-4 col-lg-12 col-md-12 col-sm-12 scheduler-component-container">
            <div className="appointment-title">Appointments</div>
            <CalendarComponent
              change={(e) => {
                setCalendarDate(e.value.toLocaleString().slice(0, 10));
              }}
            ></CalendarComponent>

            <div className="appointments-listing-container">
              {DayAppointments.length === 0 && (
                <div className="no-data-found-container">
                  <NoDataFound />
                </div>
              )}
              {DayAppointments &&
                DayAppointments.map((appointment) => (
                  <AppointmentListingCard appointment={appointment} />
                ))}
            </div>

            <Link to="/user/appointments" className="more">
              <div className="title">See More</div>
              <svg
                width="20"
                height="14"
                viewBox="0 0 20 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 6.1C0.502944 6.1 0.1 6.50294 0.1 7C0.1 7.49706 0.502944 7.9 1 7.9L1 6.1ZM19.6364 7.6364C19.9879 7.28493 19.9879 6.71508 19.6364 6.36361L13.9088 0.63604C13.5574 0.284568 12.9875 0.284568 12.636 0.63604C12.2846 0.987512 12.2846 1.55736 12.636 1.90883L17.7272 7L12.636 12.0912C12.2846 12.4426 12.2846 13.0125 12.636 13.364C12.9875 13.7154 13.5574 13.7154 13.9088 13.364L19.6364 7.6364ZM1 7.9L19 7.9L19 6.1L1 6.1L1 7.9Z"
                  fill="#808080"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>

      {/* )} */}
    </Fragment>
  );
};

export default Dashboard;
